import React, { useState } from 'react';
import styles from './EventCard.module.scss';
import dummy from '../../../assets/images/defaultNews.png';
const calendar = '/icons/calendar.svg';
const clock = '/icons/clock.svg';
const arowDown = '/icons/downArrow.svg';
const location = '/icons/location-pin.svg';
import Text from '../../atoms/text/Text';
import { useMediaQuery } from 'react-responsive';
import ReadMoreModal from '../../organism/readMoreModal/ReadMoreModal';
import defaultImage from '../../../assets/images/defaultNews.png';
import HtmlTag from '../htmlTag/HtmlTag';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
import { useTranslation } from 'react-i18next';
import useIsRtl from '../../../app/helpers/isRtl';
import { useNavigate } from 'react-router-dom';
import InnerButton from '../../atoms/innerButton/innerButton';
import parseEventStart from '../../../app/helpers/parseEventStart';

export const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${hours.toString().padStart(2, '0')} : ${minutes
    .toString()
    .padStart(2, '0')} ${ampm}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day} / ${month} / ${year}`;
};
const EventCard = ({
  id,
  title,
  date,
  time,
  categoryName,
  url,
  locationLink,
  description,
  imgUrl1,
  imgUrl2,
  imgUrl3,
  registerLink,
}) => {
  const navigate = useNavigate();
  const isRtl = useIsRtl();
  const [externalShowMore, setExternalShowMore] = useState(false);
  const isTablet = useMediaQuery({ maxWidth: 1200 });

  const handleError = (e) => {
    e.target.src = defaultImage;
  };

  const sanitizedImgUrl1 = sanitizeAndValidateUrl(
    imgUrl1 ? `${url}${imgUrl1}` : dummy
  );
  const sanitizedImgUrl2 = sanitizeAndValidateUrl(
    imgUrl2 ? `${url}${imgUrl2}` : dummy
  );
  const sanitizedImgUrl3 = sanitizeAndValidateUrl(
    imgUrl3 ? `${url}${imgUrl3}` : dummy
  );

  const images = [
    imgUrl1 ? `${url}${imgUrl1}` : null,
    imgUrl2 ? `${url}${imgUrl2}` : null,
    imgUrl3 ? `${url}${imgUrl3}` : null,
  ]
    .filter(Boolean)
    .map((img) => sanitizeAndValidateUrl(img || dummy));

  if (images.length === 0) {
    images.push(dummy);
  }
  const canShowRegister = (dateStr, timeStr) => {
    const start = parseEventStart(dateStr, timeStr);
    if (!start) return false;
    return Date.now() < start.getTime();
  };
  return (
    <div className={styles['eventCard-container']}>
      <div className={styles.imageContainer}>
        {images.length === 1 && (
          <img
            src={images[0]}
            className={styles.fullSingle}
            onError={handleError}
            loading="lazy"
            alt="Event"
          />
        )}

        {images.length === 2 && (
          <>
            <img
              src={images[0]}
              className={styles.fullWidthHalfHeight}
              onError={handleError}
              loading="lazy"
              alt="Event"
            />
            <img
              src={images[1]}
              className={styles.fullWidthHalfHeight}
              onError={handleError}
              loading="lazy"
              alt="Event"
            />
          </>
        )}

        {images.length === 3 && (
          <>
            <img
              src={images[1]}
              className={styles.fullHeight}
              onError={handleError}
              loading="lazy"
              alt="Event"
            />
            <div className={styles.halfHeightContainer}>
              <img
                src={images[0]}
                className={styles.halfHeight}
                onError={handleError}
                loading="lazy"
                alt="Event"
              />
              <img
                src={images[2]}
                className={styles.halfHeight}
                onError={handleError}
                loading="lazy"
                alt="Event"
              />
            </div>
          </>
        )}
      </div>

      <div className={styles['eventsContent']}>
        <div className={styles.info}>
          <div className={styles.titles}>
            <Text
              svg={calendar}
              svgPosition={isRtl ? 'right' : 'left'}
              title={formatDate(date)}
              variant="text-bold-italic-20-black"
              className={styles.text}
              fill="brightness(0) saturate(100%)"
              style={{ direction: 'ltr' }}
            />
            <span className={styles['time-category']}>|</span>
            <Text
              svg={clock}
              svgPosition={isRtl ? 'right' : 'left'}
              title={formatTime(time)}
              variant="text-bold-italic-20-black"
              className={styles.text}
              fill="brightness(0) saturate(100%)"
              style={{
                direction: 'ltr',
              }}
            />
            {/* <Text
              title={categoryName}
              variant="text-bold-italic-16-black"
              className={styles.text}
              fill="brightness(0) saturate(100%)"
            /> */}
          </div>
          <Text
            svg={location}
            svgPosition="left"
            title={locationLink}
            variant="text-regular-18"
            className={styles.text}
            fill="brightness(0) saturate(100%)"
            color="#1a1a1a"
          />
          {registerLink && canShowRegister(date, time) ? (
            <a
              href={
                registerLink.startsWith('http')
                  ? registerLink
                  : `https://${registerLink}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.registerLink} ${isRtl ? styles['registerLink-rtl'] : ''}`}
            >
              <InnerButton
                title="home.register"
                buttonClassName={styles['link-button']}
              />
            </a>
          ) : null}
        </div>
        <div className={styles.desc}>
          <Text
            title={title}
            variant="text-bold-italic-20-black"
            className={styles.text}
            fill="brightness(0) saturate(100%)"
            maxLines={20}
            originalData={title}
          />
          <HtmlTag
            title={description}
            variant="text-regular-14"
            fill="brightness(0) saturate(100%)"
            maxLines={isTablet ? 20 : 9}
            color="#1a1a1a"
            // originalData={description}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: isRtl ? 'flex-start' : 'flex-end',
            flexDirection: isRtl ? 'row-reverse' : '',
          }}
        >
          <Text
            title="common.read_more"
            variant="text-bold-italic-16"
            style={{ cursor: 'pointer' }}
            svg={arowDown}
            svgPosition={isRtl ? 'right' : 'left'}
            color="#1a1a1a"
            fill="brightness(0) saturate(100%)"
            // onClick={() => setExternalShowMore(true)}
            onClick={() => {
              if (id) {
                navigate(`/news-and-events/news/events-${id}`, {
                  state: {
                    type: 'events',
                    title,
                    date,
                    time,
                    categoryName,
                    url,
                    locationLink,
                    description,
                    image: [`${url}${imgUrl1}`, `${url}${imgUrl2}`],
                  },
                });
              } else {
                setExternalShowMore(true);
              }
            }}
          />
        </div>
      </div>
      <ReadMoreModal
        isOpen={externalShowMore}
        closeModal={() => setExternalShowMore(false)}
        title={title}
        description={description}
        date={formatDate(date)}
        time={formatTime(time)}
        categoryName={categoryName}
        locationLink={locationLink}
        isTitled
        image={[sanitizedImgUrl1, sanitizedImgUrl2, sanitizedImgUrl3]}
      />
    </div>
  );
};

const MultyEventsCard = ({
  id,
  title,
  date,
  time,
  categoryName,
  url,
  locationLink,
  description,
  imgUrl1,
  imgUrl2,
  registerLink,
}) => {
  const navigate = useNavigate();

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = currentLanguage !== 'en';
  const [externalShowMore, setExternalShowMore] = useState(false);

  const handleError = (e) => {
    e.target.src = defaultImage;
  };

  const sanitizedImgUrl1 = sanitizeAndValidateUrl(
    imgUrl1 ? `${url}${imgUrl1}` : dummy
  );
  const sanitizedImgUrl2 = sanitizeAndValidateUrl(
    imgUrl2 ? `${url}${imgUrl2}` : dummy
  );
  const canShowRegister = (dateStr, timeStr) => {
    const start = parseEventStart(dateStr, timeStr);
    if (!start) return false;
    return Date.now() < start.getTime();
  };
  return (
    <div className={styles['multyEventCard-container']}>
      <div className={styles.imageContainer}>
        <div className={styles.halfHeightContainer}>
          <img
            src={sanitizedImgUrl1}
            className={styles.image1}
            onError={handleError}
            alt="Event"
            loading="lazy"
          />
          <img
            src={sanitizedImgUrl2}
            className={styles.image2}
            onError={handleError}
            alt="Event"
          />
        </div>
      </div>
      <div className={styles['eventsContent']}>
        <div className={styles.info}>
          <Text
            title={categoryName}
            variant="text-bold-italic-20-black"
            className={styles.text}
            fill="brightness(0) saturate(100%)"
            style={{ textTransform: 'uppercase' }}
          />
          <div className={styles.titles}>
            <Text
              svg={calendar}
              svgPosition={isRtl ? 'right' : 'left'}
              title={formatDate(date)}
              variant="text-bold-italic-20-black"
              className={styles.text}
              fill="brightness(0) saturate(100%)"
              style={{ direction: 'ltr' }}
            />
            <span className={styles['time-category']}>|</span>
            <Text
              svgPosition={isRtl ? 'right' : 'left'}
              svg={clock}
              title={formatTime(time)}
              variant="text-bold-italic-20-black"
              className={
                !isRtl ? styles.text : `${styles.text} ${styles.rtlText}`
              }
              fill="brightness(0) saturate(100%)"
              style={{ direction: 'ltr' }}
            />
          </div>
          {locationLink ? (
            <Text
              svg={location}
              svgPosition="left"
              title={locationLink}
              variant="text-bold-italic-20-black"
              className={styles.text}
              fill="brightness(0) saturate(100%)"
              style={{ textTransform: 'uppercase', marginTop: '1rem' }}
            />
          ) : (
            <div className={styles.replaceSpace}></div>
          )}
          {registerLink && canShowRegister(date, time) ? (
            <a
              href={
                registerLink.startsWith('http')
                  ? registerLink
                  : `https://${registerLink}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.registerLink} ${isRtl ? styles['registerLink-rtl'] : ''}`}
            >
              <InnerButton
                title="home.register"
                buttonClassName={styles['link-button']}
              />
            </a>
          ) : null}
        </div>
        <div className={styles.desc}>
          <Text
            title={title}
            variant="text-bold-italic-16-black"
            className={`title-ar ${styles.text}`}
            fill="brightness(0) saturate(100%)"
            style={{ textTransform: 'uppercase', marginTop: '1rem' }}
            maxLines={2}
          />
          <HtmlTag
            title={description}
            variant="text-regular-16"
            fill="brightness(0) saturate(100%)"
            maxLines={5}
            style={{ marginTop: '1rem' }}
            color="#1a1a1a"
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: isRtl ? 'flex-start' : 'flex-end',
            flexDirection: isRtl ? 'row-reverse' : '',
          }}
        >
          <Text
            title="common.read_more"
            variant="text-bold-italic-16"
            style={{ cursor: 'pointer' }}
            svg={arowDown}
            svgPosition={isRtl ? 'right' : 'left'}
            color="#1a1a1a"
            fill="brightness(0) saturate(100%)"
            // onClick={() => setExternalShowMore(true)}
            onClick={() => {
              if (id) {
                navigate(`/news-and-events/news/events-${id}`, {
                  state: {
                    type: 'events',
                    title,
                    date,
                    time,
                    categoryName,
                    url,
                    locationLink,
                    description,
                    image: [`${url}${imgUrl1}`, `${url}${imgUrl2}`],
                  },
                });
              } else {
                setExternalShowMore(true);
              }
            }}
          />
        </div>
      </div>
      <ReadMoreModal
        isOpen={externalShowMore}
        closeModal={() => setExternalShowMore(false)}
        title={title}
        description={description}
        date={formatDate(date)}
        time={formatTime(time)}
        categoryName={categoryName}
        locationLink={locationLink}
        isTitled
        image={[sanitizedImgUrl1, sanitizedImgUrl2]}
      />
    </div>
  );
};
const EventCardAlumni = ({
  title,
  date,
  time,
  categoryName,
  url,
  locationLink,
  description,
  imgUrl1,
  imgUrl2,
  imgUrl3,
  isRtl,
}) => {
  const [externalShowMore, setExternalShowMore] = useState(false);
  const isTablet = useMediaQuery({ maxWidth: 1200 });

  const handleError = (e) => {
    e.target.src = defaultImage;
  };

  const sanitizedImgUrl1 = sanitizeAndValidateUrl(
    imgUrl1 ? `${url}${imgUrl1}` : defaultImage
  );
  const sanitizedImgUrl2 = sanitizeAndValidateUrl(
    imgUrl2 ? `${url}${imgUrl2}` : defaultImage
  );
  const sanitizedImgUrl3 = sanitizeAndValidateUrl(
    imgUrl3 ? `${url}${imgUrl3}` : defaultImage
  );

  return (
    <div className={styles['eventCard-container-alumni']}>
      <div className={styles.imageContainer}>
        <img
          src={sanitizedImgUrl2}
          className={styles.fullHeight}
          onError={handleError}
          loading="lazy"
          alt="Event"
        />
        <div className={styles.halfHeightContainer}>
          <img
            src={sanitizedImgUrl1}
            className={styles.halfHeight}
            onError={handleError}
            loading="lazy"
            alt="Event"
          />
          <img
            src={sanitizedImgUrl3}
            className={styles.halfHeight}
            onError={handleError}
            loading="lazy"
            alt="Event"
          />
        </div>
      </div>
      <div className={styles['eventsContent']}>
        <div className={styles.info}>
          <div className={styles.titles}>
            <Text
              svg={calendar}
              svgPosition="left"
              title={formatDate(date)}
              variant="text-bold-italic-16"
              className={`${styles.text} ${isRtl ? styles.textRtl : ''}`}
            />
            <Text
              svg={clock}
              svgPosition="left"
              title={formatTime(time)}
              variant="text-bold-italic-16"
              className={`${styles.text} ${isRtl ? styles.textRtl : ''}`}
            />
            <Text
              title={categoryName}
              variant="text-bold-italic-16"
              className={`${styles.text} ${isRtl ? styles.CatRtl : ''}`}
              style={{ justifyContent: isRtl ? 'right' : '' }}
            />
          </div>
          <Text
            svg={location}
            svgPosition="left"
            title={locationLink}
            variant="text-bold-italic-16"
            className={styles.text}
          />
        </div>
        <div className={styles.desc}>
          <Text
            title={title}
            variant="text-bold-italic-16"
            className={styles.text}
            maxLines={2}
          />
          {!isTablet && (
            <HtmlTag
              title={description}
              variant="text-bold-italic-16"
              maxLines={isTablet ? 20 : 4}
            />
          )}
        </div>
        <Text
          title="common.read_more"
          variant="text-bold-italic-16"
          style={{
            textTransform: 'uppercase',
            cursor: 'pointer',
            textAlign: 'right',
          }}
          svg={arowDown}
          svgPosition="right"
          onClick={() => setExternalShowMore(true)}
        />
      </div>
      <ReadMoreModal
        isOpen={externalShowMore}
        closeModal={() => setExternalShowMore(false)}
        title={title}
        description={description}
        date={formatDate(date)}
        time={formatTime(time)}
        categoryName={categoryName}
        locationLink={locationLink}
        isTitled
        image={[sanitizedImgUrl1, sanitizedImgUrl2, sanitizedImgUrl3]}
      />
    </div>
  );
};
export { EventCard, MultyEventsCard, EventCardAlumni };
